(function () {
    angular.module('active-rectangle-connector.dir', [])
        .directive('activeRectangleConnector', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeRectangleConnector]);

    function activeRectangleConnector($rootScope, $compile, $templateCache, helpers, canvasService)  {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

            }],
            link: function (scope, elem, attr) {

                if ($rootScope.aElement) {
                    // bullet proving multiple targets
                    if (document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/conditions/active-rectangle-connector');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.label = $rootScope.aElement.label;
                    scope.elemClass = $rootScope.aElement.elemClass;

                    delete $rootScope.aElement;

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);
                }
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/conditions/active-rectangle-connector.js